<template>
  <button :class="[this.colorClass]" :style="getWidth" @click="click"><i v-if="iconClass" class="fa" :class="getIconFAClass"></i><slot></slot></button>
</template>

<script>
export default {
    name: 'action-button',    
    props : {
        iconClass : {
            type : String,
            required: false
        },
        colorClass : {
            type : String,
            default : 'green'
        }, 
        width : {
            type: Number,
            required: false
        },
        loading : {
            type: Boolean,
            default: false
        }
    }, 
    computed: {        
        getWidth() {
            return  {
                width: this.width ? this.width+'px' : 'auto'
            }            
        },
        getIconFAClass() {
            if(this.iconClass) {
                let classes= [this.iconClass];
                if(this.loading) {
                    classes = ['fa-spinner','fa-spin']
                }
                return classes;
            }
            return '';
        }
    }, 
    methods: {
        click(event) {
            this.$emit('click', event);
        }
    }
}
</script>

<style scoped lang="sass">

.yellow
    --main-color : #ecc358
    --darkest-main-color : #cb9917
.green
    --main-color : #5c7c7e
    --darkest-main-color : #405658
.red
    --main-color : #ED6F6D
    --darkest-main-color : #9a1512


button
    display: flex
    justify-content: space-around
    margin-right: 10px                
    border: none
    height: 40px
    border-radius: 30px
    font-size: 16px
    cursor: pointer
    padding: 10px 15px
    background-color: var(--main-color)
    font-weight: 600
    color: #fff     

    .fa
        margin-right: 5px        
         

    &:hover
        background-color: var(--darkest-main-color)
    
    &:disabled
        background-color: lightgrey
        color: white


</style>


// WEBPACK FOOTER //
// application/assets/js/professional/containers/Common/ActionButton.vue